import React, { useState } from "react";
import SearchBar from "../../reusebale/searchBar";
import db from "../../../db/index.json";
import LeaseTable from "../maintenance/leaseTable";
import MaintenanceFilterPopUp from "../../popup/MaintenanceFilterPopUp";
import DetailMain from "../maintenance/maintanance-detail/detailMain";

const MaintainanceSection = () => {
  const { maintainances } = db;
  const [showTable, setShowTable] = useState("table");

  const [showFilter, setShowFilter] = useState(false);
  const [recordId, setRecordId] = useState()

  const openPopup = () => {
    setShowFilter(true);
  };

  const closePopup = () => {
    setShowFilter(false);
  };

  const toggleDetail = () => {
    setShowTable("detail"); // State toggle karein
  };

  const toggleCreate = () => {
    setShowTable("create"); // State toggle karein
  };

  const toggleTable = () => {
    setShowTable("table"); // State toggle karein
  };


  const [status, setStatus] = useState("All")
  const [search, setSearch] = useState("")


  return (
    <div className="">
      {/* <SearchBar title={maintainances.title} desc={maintainances.description} onSubmit={openPopup}/>
      <LeaseTable /> */}
      {(() => {
        switch (showTable) {
          case "table":
            return (
              <div className="h-screen w-full">
                <div className="h-[10vh]">
                  <SearchBar
                    isFilter
                    onChange={(e) => {
                      setSearch(e.target.value)
                    }}
                    title={maintainances.title}
                    desc={maintainances.description}
                    onSubmit={openPopup}
                  />
                </div>
                <div className="h-[90vh]">
                  <LeaseTable
                    status={status}
                    search={search}
                    onViewDetails={(item) => {
                      setRecordId(item)
                      toggleDetail(item)
                    }}
                    onViewCreate={toggleCreate}
                  />
                </div>
              </div>
            );
          case "detail":
            return <DetailMain recordId={recordId._id} onBack={toggleTable} />;
          default:
            break;
        }
      })()}
      {showFilter && <MaintenanceFilterPopUp closePopup={closePopup} onBack={closePopup} onFilter={(status) => {
        setStatus(status)
        closePopup()
      }} />}
    </div>
  );
};

export default MaintainanceSection;
